var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 15C1 7.26802 7.26802 1 15 1C22.732 1 29 7.26802 29 15C29 22.732 22.732 29 15 29C7.26802 29 1 22.732 1 15Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.3333 10.3335L19.6666 19.6668M19.6666 10.3335L10.3333 19.6668",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDark);
export default __webpack_public_path__ + "static/media/close-dark.8045f5670e51b626425f61e483d8831c.svg";
export { ForwardRef as ReactComponent };